// extracted by mini-css-extract-plugin
export default {"description":"style_description__6CPod","fade-in":"style_fade-in__E0z6a","top":"style_top__7RzQc","image":"style_image__IJs43"};